var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "logo_img" }, [_vm._v("amway")]),
    _vm._v(" "),
    _c("div", { staticClass: "mask_index-wrap" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "mask_info" }, [
        _c("p", { staticClass: "product_logo" }, [_vm._v("atomsphere sky")]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-floating" }, [
          _c("div", { staticClass: "box_button-a" }, [
            _c(
              "button",
              {
                staticClass: "btn_mobile open_reservation",
                attrs: { type: "button" },
                on: { click: _vm.gotoreserv }
              },
              [_c("i", { staticClass: "ico_01" }), _vm._v("마스크 예약")]
            )
          ]),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c("p", { staticClass: "txt_noti" }, [
            _vm._v("다른 제품 주문을 위해 amway.co.kr 홈으로 이동합니다.")
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(5)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mask_img pc_block" }, [
      _c("img", {
        attrs: { src: require("./images/main_product.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "product_name" }, [
      _vm._v("엣모스피어 스카이"),
      _c("br"),
      _c("span", { staticClass: "txt_strong" }, [_vm._v("미세먼지마스크")]),
      _c("span", { staticClass: "txt_kf" }, [_vm._v("KF94")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "product_info" }, [
      _vm._v("엣모스피어 스카이 미세먼지마스크 KF94(의약외품)는 4중구조의 "),
      _c("br"),
      _vm._v("KF94 필터를 적용해 미세먼지와 황사로부터 호흡기를 보호해줍니다.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mask_img m_block" }, [
      _c("img", {
        attrs: { src: require("./images/main_product.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box_button-b st_type02" }, [
      _c(
        "a",
        {
          staticClass: "btn_type-b",
          staticStyle: { display: "none" },
          attrs: { href: "https://www.amway.co.kr/register" }
        },
        [_vm._v("회원가입")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn_type-c",
          attrs: { href: "https://www.amway.co.kr" }
        },
        [_vm._v("암웨이 홈으로")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layer_popup layer_reservation" }, [
      _c("object", {
        attrs: {
          id: "",
          width: "100%",
          height: "100%",
          data: "mask_reservations_2.html"
        }
      }),
      _vm._v(" "),
      _c("button", { staticClass: "layer_close", attrs: { type: "button" } }, [
        _vm._v("닫기")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36cc16d0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36cc16d0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/atmosphere-mask/index.vue
// module id = null
// module chunks = 